export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY
  ?? process.env.REACT_APP_ADMIN_MAPS_API_KEY
  ?? '';

export const GOOGLE_MAPS_MAP_ID = process.env.REACT_APP_GOOGLE_MAPS_MAP_ID
  ?? process.env.REACT_APP_ADMIN_MAPS_MAP_ID
  ?? 'DEMO_MAP_ID';

export const getGoogleMapOptions = (
  overrides: google.maps.MapOptions = {}
): google.maps.MapOptions => ({
  mapId: GOOGLE_MAPS_MAP_ID,
  ...overrides
});
